import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';

const initialState = []


export default function appReducer(state = initialState, action) {
    // console.log("app reducer", action)
    switch (action.type) {
        case types.ADD_SECTION: {
            return [
            ...state, 
            action.payload
            ]            
        }

        case types.EDIT_SECTION: {
            return [ ...state.map( section => section.id == action.payload.id ? (action.payload) : ({ ...section })  )]
        }

        case types.DELETE_SECTION: {
            return state.filter(section => section.id !== action.payload.id) 
        }

        case types.UPDATE_FULL_SECTIONS: {
            return [
                ...state,
                ...action.payload
            ]
        }

        case types.UPDATE_REORDERED_SECTIONS: {
           
            return [...action.payload]
        }

        case 'RESET_BLUEPRINT':
            return cloneDeep(initialState);


        default:
        return state;
    }
  }
  